export const keywordKey = (value) => String(value).trim().toLowerCase();

export function normalizeKeywords(values = []) {
  const unique = new Map();
  for (const value of values || []) {
    const keyword = String(value).trim();
    if (keyword && !unique.has(keywordKey(keyword))) {
      unique.set(keywordKey(keyword), keyword);
    }
  }
  return [...unique.values()];
}

export function businessKeywordsFirst(values = [], businessKeywords = []) {
  const business = new Set((businessKeywords || []).map(keywordKey));
  const selected = normalizeKeywords(values);
  return [
    ...selected.filter((keyword) => business.has(keywordKey(keyword))),
    ...selected.filter((keyword) => !business.has(keywordKey(keyword))),
  ];
}

export const splitKeywords = (text) => text.split(/[,;\n\r\t]+/);
